import { render, staticRenderFns } from "./IncomeStaMovieDetail.vue?vue&type=template&id=458ed55b&scoped=true"
import script from "./IncomeStaMovieDetail.vue?vue&type=script&lang=js"
export * from "./IncomeStaMovieDetail.vue?vue&type=script&lang=js"
import style0 from "./IncomeStaMovieDetail.vue?vue&type=style&index=0&id=458ed55b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458ed55b",
  null
  
)

export default component.exports